<template>
  <el-dialog 
    title="选择组织" 
    :visible.sync="dialogVisible"
    width="80%"
  >
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card header="flex justify-between">
          <el-row :gutter="20">
            <el-col :span="18"></el-col>
            <el-col :span="6">
              <el-input 
                placeholder="输入组织名称" 
                v-model="chooseOrgInfo._currentOrgName"
                class="input-with-button"
              >
                <el-button 
                  slot="append" 
                  icon="el-icon-search"
                  @click="queryOrgs()"
                >查询</el-button>
              </el-input>
            </el-col>
          </el-row>
          <el-table 
            :data="chooseOrgInfo.orgs" 
            style="width: 100%"
            border
          >
            <el-table-column prop="orgId" label="组织ID" align="center"></el-table-column>
            <el-table-column prop="orgName" label="组织名称" align="center"></el-table-column>
            <el-table-column prop="orgLevelName" label="组织级别" align="center"></el-table-column>
            <el-table-column prop="parentOrgName" label="上级ID" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button 
                  type="primary" 
                  size="mini"
                  @click="chooseOrg(scope.row)"
                >选择</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { listOrgs } from '@/api/frame/chooseOrgApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ChooseOrg',
  props: {
    emitChooseOrg: String,
    emitLoadData: String
  },
  data() {
    return {
      dialogVisible: false,
      chooseOrgInfo: {
        orgs: [],
        _currentOrgName: '',
        orgLevel: '',
        parentOrgId: '',
      }
    }
  },
  methods: {
    open(params) {
      Object.assign(this.chooseOrgInfo, params)
      this.dialogVisible = true
      this._refreshChooseOrgInfo()
      this._loadAllOrgInfo(1, 10, '')
    },
    async _loadAllOrgInfo(page, row, name) {
      try {
        const params = {
          page,
          row,
          shopId: getShopId(),
          orgName: name,
          orgLevel: this.chooseOrgInfo.orgLevel,
          parentOrgId: this.chooseOrgInfo.parentOrgId,
        }
        const res = await listOrgs(params)
        this.chooseOrgInfo.orgs = res.data.orgs
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    chooseOrg(org) {
      if (Object.prototype.hasOwnProperty.call(org, 'name')) {
        org.orgName = org.name
      }
      this.$emit(this.emitChooseOrg, 'chooseOrg', org)
      this.$emit(this.emitLoadData, 'listOrgData', {
        orgId: org.orgId
      })
      this.dialogVisible = false
    },
    queryOrgs() {
      this._loadAllOrgInfo(1, 10, this.chooseOrgInfo._currentOrgName)
    },
    _refreshChooseOrgInfo() {
      this.chooseOrgInfo._currentOrgName = ""
    }
  }
}
</script>

<style scoped>
.input-with-button {
  margin-bottom: 20px;
}
</style>